import {array, mixed, number, object, string} from "yup";
import {AMPLITUDE_MAX_H, AMPLITUDE_MIN_H, PERIODE_MAX_JOURS, pointPourPayload} from "./simulationRules";

/**
 * Schéma de validation du formulaire de simulation, partagé par le wizard V1 et l'atelier (lot 4) :
 * mêmes champs, mêmes messages. `schemaAtelier` rend le libellé facultatif (un brouillon reçoit un libellé généré).
 */
export const joursEntre = (du, au) => Math.round((new Date(`${au}T00:00:00Z`) - new Date(`${du}T00:00:00Z`)) / 86400000) + 1;
const pointValide = (v) => v != null && pointPourPayload(v) != null;
const numeriquePositif = (label) => number().typeError(`${label} : nombre attendu`).moreThan(0, `${label} : valeur > 0`).required(`${label} requis`);

export const schema = object({
    libelle: string().trim().required("Le libellé est requis").max(120, "120 caractères au plus"),
    du: string().required("Date de début requise"),
    au: string().required("Date de fin requise").test('apres-du', "La fin doit être postérieure ou égale au début",
        function (au) { return !au || !this.parent.du || au >= this.parent.du; })
        .test('max', `Période limitée à ${PERIODE_MAX_JOURS} jours`,
            function (au) { return !au || !this.parent.du || au < this.parent.du || joursEntre(this.parent.du, au) <= PERIODE_MAX_JOURS; }),
    nbEquipes: number().typeError("Nombre attendu").integer("Entier attendu").min(1, "1 à 5").max(5, "1 à 5").required(),
    base: mixed().test('base', "Choisissez une agence ayant des coordonnées, ou géocodez une adresse", pointValide),
    depot: mixed().nullable().test('depot', "Géocodez l'adresse du dépôt ou choisissez une agence", (v) => v == null || pointValide(v)),
    tolerances: array().of(object({
        flux: string().trim().required("Flux requis"),
        jours: number().typeError("Nombre attendu").integer("Entier attendu").min(0, "≥ 0").required("Jours requis"),
    })),
    heuresParJour: numeriquePositif("Heures par jour"),
    joursParSemaine: number().typeError("Nombre attendu").integer("Entier attendu").min(1).max(7, "1 à 7").required(),
    amplitudeMaxH: number().typeError("Nombre attendu").min(AMPLITUDE_MIN_H, `${AMPLITUDE_MIN_H} à ${AMPLITUDE_MAX_H} h`).max(AMPLITUDE_MAX_H, `${AMPLITUDE_MIN_H} à ${AMPLITUDE_MAX_H} h`)
        .test('pas', "Par pas de 0,5 h", (v) => v == null || Number.isInteger(v * 2)).required("Amplitude max requise"),
    horizonJournees: number().transform((v, o) => (o === '' ? undefined : v)).integer("Entier attendu").moreThan(0, "> 0").notRequired(),
    miseEnPlaceMin: number().typeError("Nombre attendu").min(0).required(),
    tBacMin: numeriquePositif("t_bac"),
    kSeul: numeriquePositif("k seul"),
    vitesseKmH: numeriquePositif("Vitesse"),
    vitesseTrajetKmH: numeriquePositif("Vitesse trajet"),
    seuilBacsParHeure: number().typeError("Nombre attendu").min(0).required(),
    heureDebutJournee: string().matches(/^([01]\d|2[0-3]):[0-5]\d$/, "Format HH:MM").required(),
    coutKm: number().typeError("€/km requis").min(0, "≥ 0").required("€/km requis (saisi, jamais pré-rempli)"),
    coutHoraire: number().transform((v, o) => (o === '' ? undefined : v)).min(0, "≥ 0").notRequired(),
    forfaitDeplacement: number().transform((v, o) => (o === '' ? undefined : v)).min(0, "≥ 0").notRequired(),
});


export const schemaAtelier = schema.shape({
    libelle: string().trim().max(120, "120 caractères au plus"),
});
